/** Legal copy aligned with WasOK `docs/PRIVACY_POLICY.md` / `docs/TERMS_OF_SERVICE.md`. */
export const legalMessagesPt = {
  privacy: {
    pageTitle: "Política de Privacidade",
    lastUpdated: "Última atualização: 1 de junho de 2026",
    introduction: {
      title: "Introdução",
      body: "O WasOK é um aplicativo de apoio às compras com armazenamento local, projetado para ajudar os usuários a lembrar produtos que compraram, avaliaram ou revisaram anteriormente.\n\nEsta Política de Privacidade explica quais informações são processadas ao usar o app, como os dados são armazenados e como determinados serviços de terceiros podem operar.",
    },
    dataStored: {
      title: "Dados armazenados pelo app",
      body: "O WasOK armazena as seguintes informações localmente no seu dispositivo:\n\n• códigos de barras de produtos escaneados\n• nomes e detalhes de produtos inseridos pelo usuário\n• avaliações e comentários\n• listas de compras\n• categorias de produtos\n• preços e informações de lojas\n• fotos de produtos e lojas\n\nSeus dados de produtos e fotos não são enviados para os servidores do WasOK.",
    },
    permissions: {
      title: "Permissões utilizadas",
      camera: {
        title: "Câmera",
        body: "O acesso à câmera é usado para:\n\n• escanear códigos de barras\n• tirar fotos de produtos",
      },
      photos: {
        title: "Fotos e mídia",
        body: "O acesso a fotos ou à galeria é usado apenas quando:\n\n• você anexa imagens a produtos\n• restaura backups que contêm fotos",
      },
      files: {
        title: "Acesso a arquivos e armazenamento",
        body: "O acesso a arquivos pode ser usado para:\n\n• exportar arquivos de backup\n• importar backups selecionados pelo usuário\n• compartilhar listas de compras ou backups",
      },
    },
    backup: {
      title: "Backup e exportação",
      body: "O WasOK permite que os usuários criem arquivos de backup contendo dados do app e fotos opcionais.\n\nOs arquivos de backup são criados localmente no seu dispositivo e podem ser armazenados ou compartilhados usando serviços escolhidos pelo usuário, como:\n\n• Google Drive\n• Dropbox\n• iCloud Drive\n• armazenamento local do dispositivo\n\nO WasOK não envia backups para seus próprios servidores.",
      onlineProductLookup: {
        title: "Consulta de produtos online",
        body: "Quando você ativa a consulta online de códigos de barras nas Preferências, o WasOK pode enviar apenas o número do código de barras escaneado para bancos de dados públicos de produtos (como o Open Food Facts) para sugerir nome e marca do produto. O WasOK não envia suas avaliações, comentários, fotos, listas de compras, categorias, informações de lojas ou dados de backup para esse recurso. Você pode desativá-lo a qualquer momento nas Preferências.",
      },
    },
    advertising: {
      title: "Publicidade e serviços de terceiros",
      intro:
        "O WasOK usa serviços de terceiros selecionados para fornecer determinados recursos.",
      admob: {
        title: "Google AdMob",
        body: "O Google AdMob é usado para exibir anúncios no app.\n\nO Google e seus parceiros podem processar informações como:\n\n• identificadores de publicidade\n• informações do dispositivo\n• endereço IP\n• dados de diagnóstico e de uso\n\nUsuários em determinadas regiões podem ser solicitados a consentir antes da exibição de anúncios personalizados.",
      },
      crashlytics: {
        title: "Firebase Crashlytics",
        body: "O WasOK usa o Firebase Crashlytics para ajudar a identificar falhas e melhorar a estabilidade do app.\n\nRelatórios de falhas podem incluir informações técnicas como:\n\n• modelo do dispositivo\n• versão do sistema operacional\n• versão do app\n• diagnósticos de falha\n\nOs relatórios de falhas não incluem intencionalmente suas avaliações de produtos, notas, listas de compras ou fotos.",
      },
      externalProductDatabases: {
        title: "Bancos de dados de produtos externos",
        body: "A funcionalidade de consulta de códigos de barras pode usar bancos de dados de produtos externos para recuperar informações sobre produtos.\n\nPara mais informações, consulte as políticas de privacidade dos respectivos provedores.",
      },
    },
    dataSecurity: {
      title: "Segurança dos dados",
      body: "O WasOK armazena os dados do app localmente no seu dispositivo usando os mecanismos de armazenamento fornecidos pelo sistema operacional.\n\nEmbora sejam tomadas medidas razoáveis para proteger os dados locais do app, nenhum método de armazenamento eletrônico é completamente seguro.\n\nOs usuários são responsáveis por manter backups de dados importantes, se desejarem.",
    },
    children: {
      title: "Privacidade de crianças",
      body: "O WasOK não é destinado a crianças menores de 13 anos.",
    },
    notifications: {
      title: "Notificações",
      body: "O WasOK pode, opcionalmente, criar notificações locais no seu dispositivo para lembrar você de avaliar produtos após a compra.\n\nEssas notificações são geradas e agendadas localmente no seu dispositivo e não exigem uma conta ou servidor remoto.\n\nVocê pode desativar as notificações a qualquer momento nas configurações do dispositivo ou no app, se suportado.",
    },
    yourControl: {
      title: "Seu controle sobre os dados",
      body: "Você pode:\n\n• editar ou excluir produtos armazenados a qualquer momento\n• limpar os dados do app do seu dispositivo\n• desinstalar o app\n• exportar backups dos seus dados",
    },
    changes: {
      title: "Alterações nesta política",
      body: "Esta Política de Privacidade pode ser atualizada periodicamente.\n\nAs alterações entram em vigor quando a versão atualizada é publicada.",
    },
    contact: {
      title: "Contato",
      body: "Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato:\n\nsupport@wasok.app",
    },
  },
  terms: {
    pageTitle: "Termos de Serviço",
    lastUpdated: "Última atualização: 1 de junho de 2026",
    acceptance: {
      title: "Aceitação dos termos",
      body: "Ao baixar, instalar ou usar o WasOK, você concorda com estes Termos de Serviço.\n\nSe você não concordar com estes Termos, não deve usar o app.",
    },
    license: {
      title: "Licença",
      body: "O WasOK concede a você uma licença limitada, não exclusiva, intransferível e revogável para usar o app de acordo com estes Termos.",
    },
    acceptableUse: {
      title: "Uso aceitável",
      body: "Você concorda em não:\n\n• fazer mau uso do app\n• interferir no funcionamento do app\n• tentar fazer engenharia reversa ou modificar o app\n• usar o app em violação às leis ou regulamentos aplicáveis",
    },
    localData: {
      title: "Dados locais e backups",
      body: "O WasOK armazena os dados do usuário localmente no dispositivo.\n\nOs usuários são responsáveis por manter backups de dados importantes, se desejarem.\n\nEmbora a funcionalidade de backup e restauração possa ser fornecida, o WasOK não garante contra perda, corrupção ou falha dos dados armazenados.",
    },
    advertisements: {
      title: "Anúncios",
      body: "O app pode exibir anúncios fornecidos por parceiros de publicidade de terceiros, incluindo o Google AdMob.",
    },
    noWarranty: {
      title: "Sem garantia",
      body: "O WasOK é fornecido \"como está\" e \"conforme disponível\", sem garantias de qualquer tipo, expressas ou implícitas.\n\nNão garantimos que:\n\n• o app estará sempre disponível\n• o app estará livre de erros\n• a perda de dados nunca ocorrerá\n• todos os recursos funcionarão sem interrupção em todos os dispositivos",
    },
    limitationLiability: {
      title: "Limitação de responsabilidade",
      body: "Na máxima extensão permitida por lei, o WasOK e seus desenvolvedores não serão responsáveis por:\n\n• perda de dados\n• perda de lucros\n• problemas no dispositivo\n• danos indiretos ou consequenciais\n• interrupções resultantes do uso ou da incapacidade de usar o app",
    },
    thirdParty: {
      title: "Serviços de terceiros",
      body: "Determinados recursos ou conteúdos podem depender de serviços de terceiros, incluindo provedores de publicidade e serviços externos de armazenamento/compartilhamento selecionados pelo usuário.\n\nO WasOK não é responsável por serviços de terceiros ou por suas políticas.",
    },
    productInformation: {
      title: "Informações sobre produtos",
      body: "Determinados detalhes de produtos podem ser obtidos de serviços de consulta de códigos de barras de terceiros.\n\nO WasOK não garante a precisão, integridade, disponibilidade ou adequação das informações fornecidas por fontes de dados externas.\n\nOs usuários devem verificar independentemente as informações sobre produtos quando necessário.",
    },
    changesApp: {
      title: "Alterações no app",
      body: "O WasOK pode ser modificado, atualizado, suspenso ou descontinuado a qualquer momento sem aviso prévio.",
    },
    changesTerms: {
      title: "Alterações nestes termos",
      body: "Estes Termos podem ser atualizados periodicamente.\n\nO uso contínuo do app após as atualizações entrarem em vigor constitui aceitação dos Termos revisados.",
    },
    contact: {
      title: "Contato",
      body: "Para dúvidas sobre estes Termos, entre em contato:\n\nsupport@wasok.app",
    },
  },
};
